import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-258" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-2xl border-2 border-red-500 bg-[#16161F] p-8 text-center sm:p-11" data-id="element-259" data-mp="369pi89t3zb91">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-400" data-id="element-260" data-mp="31ipk51896n4y">
          <Clock3Icon className="h-4 w-4" data-id="element-261" data-mp="3g7c8ttjrsr8u" /> Limited-time offer
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-262" data-mp="3b9aqxby2yxyy">
          Launch price ends in:
        </h2>
        <div className="my-9" data-id="element-263" data-mp="3p8a4nok21sgc">
          <CountdownTimer size="large" dark data-id="element-264" data-mp="3p6h48r01c4gs" />
        </div>
        <p className="font-semibold text-white" data-id="element-265" data-mp="3l8jenn2crgcv">
          After that, the price goes up and bonuses are removed.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-266" data-mp="1uwvdr4fb5mz0">
          <div className="h-3 overflow-hidden border border-red-500/50 bg-[#0A0A0A]" data-id="element-267" data-mp="1qtz25xo6qr4k">
            <div className="h-full w-[72%] bg-red-500" data-id="element-268" data-mp="2su6edegrypxz" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-269" data-mp="2srtnucwyb79b">
            <span className="text-red-400" data-id="element-270" data-mp="32ruaa7q4a3hq">Limited spots</span>
            <span className="text-[#B0B0C0]" data-id="element-271" data-mp="32q9gwlfjgqlg">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}